import { motion, useReducedMotion } from 'motion/react'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router'
import { hole } from '../lib/api'
import { effectsFast, reducedFade } from '../motion/tokens'
import { Symbol } from '../ui'

/**
 * Die Glocke in der Kopfzeile.
 *
 * ⚠️ Bewusst KEIN eigenes Navigationsziel: die Leiste hat fünf Plätze, und ein
 * Posteingang ist eine Nebenhandlung - man geht hin, wenn etwas da ist, nicht
 * um dort zu arbeiten.
 *
 * ⚠️ Kein zweiter Poll. Der Zähler hängt am selben Ereignisstrom wie alles
 * andere (`lib/sse.ts` entwertet `['notifications']`), und TanStack Query holt
 * ihn dann von selbst nach. Ein eigenes Intervall wäre ein zweiter Takt, der
 * mit dem ersten aus dem Tritt gerät.
 */
export function Postzaehler() {
  const ruhig = useReducedMotion()
  const { data } = useQuery({
    queryKey: ['notifications', 'anzahl'],
    queryFn: () => hole<{ ungelesen: number }>('/api/notifications/anzahl'),
  })
  const offen = data?.ungelesen ?? 0

  return (
    <Link
      to="/posteingang"
      className="postglocke"
      aria-label={offen > 0 ? `Posteingang, ${offen} ungelesen` : 'Posteingang'}
    >
      <Symbol name="bell" />
      {/* ⚠️ Bei 0 steht hier NICHTS. Eine Null, die ständig dasteht, ist eine
          Aufforderung ohne Inhalt - und sie stumpft den Blick für die Fälle
          ab, in denen wirklich etwas da ist. */}
      {offen > 0 ? (
        <motion.span
          className="postglocke__zahl"
          // ⚠️ Die Deckkraft blendet OHNE Überschwingen auf (Hausregel aus
          // `motion/tokens.ts`). Der Fehler vom 15.09. - eine federnde Kurve
          // auf einer Blende - wird hier nicht wiederholt.
          initial={ruhig ? false : { opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={ruhig ? reducedFade : effectsFast}
        >
          {offen > 99 ? '99+' : offen}
        </motion.span>
      ) : null}
    </Link>
  )
}
